import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PostAdStep3.css';

const PostAdStep3: React.FC = () => {
  const navigate = useNavigate();
  
  const [terms, setTerms] = useState('');
  const [autoReply, setAutoReply] = useState('');
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [expandedSections, setExpandedSections] = useState<{[key: string]: boolean}>({
    tradeCalculation: false,
    tradeLimits: false,
    requirements: false,
  });
  
  const toggleSection = (section: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  
  const handlePreviewAd = () => {
    if (terms.trim() === '') {
      alert('Please enter terms and conditions');
      return;
    }
    
    if (autoReply.trim() === '') {
      alert('Please enter an auto-reply message');
      return;
    }
    
    setShowPreviewModal(true);
  };
  
  const handlePublishAd = () => {
    setShowPreviewModal(false);
    // Navigate to my-ads or show success message
    navigate('/my-ads');
  };
  
  const handleBack = () => {
    navigate('/post-ad-step-2');
  };
  
  return (
    <div className="post-ad-container">
      <header className="post-ad-header">
        <div className="post-ad-header-container">
          <button className="post-ad-back-button" onClick={handleBack} aria-label="Go back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="post-ad-title">Post an Ad</h1>
        </div>
        <div className="post-ad-progress">
          <div className="post-ad-progress-bar" style={{ width: '100%' }}></div>
        </div>
      </header>

      <div className="post-ad-content">
        <div className="post-ad-section">
          <h2 className="post-ad-section-title">Terms & auto reply</h2>
          
          <label className="post-ad-label">Terms</label>
          <p className="post-ad-hint-description">Terms and conditions for the offer.</p>
          
          <textarea
            className="post-ad-textarea"
            placeholder="Enter terms and conditions here"
            value={terms}
            onChange={(e) => setTerms(e.target.value)}
            rows={6}
          />
          
          <label className="post-ad-label">Auto Reply</label>
          <p className="post-ad-hint-description">Automatic reply message for traders.</p>
          
          <textarea
            className="post-ad-textarea"
            placeholder="Type remarks here"
            value={autoReply}
            onChange={(e) => setAutoReply(e.target.value)}
            rows={6}
          />
          
          <button className="post-ad-next-button" onClick={handlePreviewAd}>
            Preview Ad
          </button>
        </div>
      </div>

      {showPreviewModal && (
        <div className="post-ad-modal-overlay" onClick={() => setShowPreviewModal(false)}>
          <div className="post-ad-preview-modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="post-ad-preview-modal-header">
              <h2 className="post-ad-preview-modal-title">Preview Buy USDT Offer</h2>
              <button
                className="post-ad-preview-modal-close"
                onClick={() => setShowPreviewModal(false)}
                aria-label="Close modal"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>

            <div className="post-ad-preview-modal-content">
              <h3 className="post-ad-preview-heading-main">Your Offer Details</h3>

              <div className="post-ad-preview-details-card">
                <div className="post-ad-preview-detail-row">
                  <span className="post-ad-preview-label">Price:</span>
                  <span className="post-ad-preview-value">1000 NGN/USDT</span>
                </div>
                <div className="post-ad-preview-detail-row">
                  <span className="post-ad-preview-label">Payment Method:</span>
                  <span className="post-ad-preview-value-right">ZenithBank, MoniePoint, OPay</span>
                </div>
                <div className="post-ad-preview-detail-row">
                  <span className="post-ad-preview-label">Total Amount:</span>
                  <span className="post-ad-preview-value">100 USDT</span>
                </div>
              </div>

              <div className="post-ad-preview-fee-card">
                <div className="post-ad-preview-fee-header">
                  <div className="post-ad-preview-fee-indicator"></div>
                  <h4 className="post-ad-preview-fee-title">Fee Information</h4>
                </div>
                <div className="post-ad-preview-fee-row">
                  <span className="post-ad-preview-label">Fee Rate:</span>
                  <span className="post-ad-preview-value-sm">0.3% per trade</span>
                </div>
                <div className="post-ad-preview-fee-row">
                  <span className="post-ad-preview-label">Fee Type:</span>
                  <span className="post-ad-preview-value-sm">percentage</span>
                </div>
              </div>

              <div className="post-ad-preview-accordion">
                <button
                  className="post-ad-preview-expandable-button"
                  onClick={() => toggleSection('tradeCalculation')}
                >
                  <span>Example Trade Calculation</span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className={expandedSections.tradeCalculation ? 'rotated' : ''}
                  >
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                {expandedSections.tradeCalculation && (
                  <div className="post-ad-preview-accordion-content">
                    <p className="post-ad-preview-accordion-text">For a trade of 10 USDT:</p>
                    <p className="post-ad-preview-accordion-text">• Amount: 1000 × 10 = 10000.00 NGN</p>
                    <p className="post-ad-preview-accordion-text">• Fee: 30.00 NGN</p>
                  </div>
                )}
              </div>

              <div className="post-ad-preview-accordion">
                <button
                  className="post-ad-preview-expandable-button"
                  onClick={() => toggleSection('tradeLimits')}
                >
                  <span>Trade Limits</span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className={expandedSections.tradeLimits ? 'rotated' : ''}
                  >
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                {expandedSections.tradeLimits && (
                  <div className="post-ad-preview-accordion-content">
                    <p className="post-ad-preview-accordion-text">Minimum: 1000 NGN</p>
                    <p className="post-ad-preview-accordion-text">Maximum: 1000 NGN</p>
                    <p className="post-ad-preview-accordion-text">Payment time: 15 minutes</p>
                  </div>
                )}
              </div>

              <div className="post-ad-preview-accordion">
                <button
                  className="post-ad-preview-expandable-button"
                  onClick={() => toggleSection('requirements')}
                >
                  <span>Requirements</span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    className={expandedSections.requirements ? 'rotated' : ''}
                  >
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                {expandedSections.requirements && (
                  <div className="post-ad-preview-accordion-content">
                    <p className="post-ad-preview-accordion-text">• Verified account required</p>
                    <p className="post-ad-preview-accordion-text">• Payment within 15 minutes</p>
                    <p className="post-ad-preview-accordion-text">• Follow platform trading rules</p>
                  </div>
                )}
              </div>

              <div className="post-ad-preview-notice-card">
                <div className="post-ad-preview-notice-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="post-ad-preview-notice-content">
                  <h4 className="post-ad-preview-notice-title">Important Notice</h4>
                  <p className="post-ad-preview-notice-text">
                    Please review all details carefully before posting. Once posted, your offer will be visible to all users and you'll be expected to honor the terms and conditions specified.
                  </p>
                </div>
              </div>

              <button className="post-ad-preview-proceed-button" onClick={handlePublishAd}>
                PROCEED
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostAdStep3;